import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Servicii',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terasă disponibilă',
    [STORE_SERVICES.DINE_IN]: 'Masă în restaurant',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Comandă online prin FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Rezervări prin FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Rezervări în restaurant',
  },
  labels: {
    reservation_total_seats: 'Total locuri rezervare',
    catering_min_people: 'Număr minim persoane catering',
  },
};
